<template>
  <div id="Notify">
    <v-form ref="form" v-model="notifyFormValid" lazy-validation>
      <v-text-field
        label="Title*"
        maxlength="32"
        v-model="title"
        :rules="titleRules"
        required
      ></v-text-field>
      <v-text-field
        label="Text*"
        v-model="text"
        :rules="textRules"
        required
      ></v-text-field>
      <v-autocomplete
        v-model="selectedFriends"
        :items="getFriends"
        label="Send to"
        multiple
        :rules="assingRules"
        no-data-text="No friends available"
        item-text="text"
        item-value="value"
      >
        <template v-slot:prepend-item v-if="getFriends.length > 1">
          <v-list-item ripple @click="selectAll">
            <v-list-item-action>
              <v-icon
                :color="selectedFriends.length > 0 ? 'indigo darken-4' : ''"
              >
                {{ icon }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title> Select All </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-2"></v-divider>
        </template>
      </v-autocomplete>
      <v-card-actions class="mt-5">
        <v-btn color="#1E88E5" text @click="hideForm"> Close </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="#1E88E5"
          text
          :disabled="!notifyFormValid"
          @click="validate()"
        >
          Send
        </v-btn>
      </v-card-actions>
    </v-form>
  </div>
</template>

<script>
import api from "../api";

export default {
  name: "friendsList",
  data() {
    return {
      selectedFriends: [],
      assingRules: [(v) => (v && v.length > 0) || "Assign is required"],
      titleRules: [
        (v) => !!v || "Title is required",
        (v) => (v && v.length <= 32) || "Title must be less than 32 characters",
      ],
      textRules: [(v) => !!v || "Title is required"],
      title: "",
      text: "",
      notifyFormValid: true,
    };
  },
  computed: {
    selectedAll() {
      return this.selectedFriends.length === this.getFriends.length;
    },
    selectedSome() {
      return this.selectedFriends.length > 0 && !this.getFriends;
    },
    getFriends() {
      return this.$store.state.data.friends.map((el) => {
        return { text: el.name, value: el.uid };
      });
    },
    icon() {
      if (this.selectedAll) return "mdi-close-box";
      if (this.selectedSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    selectAll() {
      this.$nextTick(() => {
        if (this.selectedAll) {
          this.selectedFriends = [];
        } else {
          this.selectedFriends = this.getFriends.slice();
        }
      });
    },
    hideForm() {
      this.$parent.$parent.hide();
    },
    validate() {
      this.$refs.form.validate();
      if (this.notifyFormValid) {
        let notify = {
          title: this.title,
          text: this.text,
          sendTo: this.selectedFriends,
        };
        api.sendNotify(notify, this);
        this.hideForm();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#friendsList {
  margin: 0 auto;
  border-radius: 15px;
  .search {
    display: flex;
    align-items: center;
    padding: 0.25rem 1rem;
    margin-bottom: 15px;
    border-radius: 999px;
    transition: 0.3s all;
    border: 1px solid #aaa;
    color: #333;
    outline: none;
    input[type="text"] {
      flex-grow: 1;
      padding-left: 0.5rem;
      color: inherit;
      font-family: inherit;
      font-size: 1.25rem;
      background: transparent;
      border: none;
      outline: none;
    }
  }
}

.primary {
  color: rgb(0, 0, 155) !important;
}
</style>